import { usePermissions } from "@/hooks/use-permissions";
import { PermissaoEnum } from "@workflow/types";
import { ReactNode } from "react";

interface PermissionWrapperProps {
  permission?: PermissaoEnum;
  permissions?: PermissaoEnum[];
  requireAll?: boolean;
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionWrapper({
  permission,
  permissions,
  requireAll = false,
  children,
  fallback = null,
}: PermissionWrapperProps) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  if (!permission && !permissions) {
    return <>{children}</>;
  }

  let hasAccess = false;
  if (permission) {
    hasAccess = hasPermission(permission);
  } else if (permissions) {
    hasAccess = requireAll ? hasAllPermissions(permissions) : hasAnyPermission(permissions);
  }

  if (!hasAccess) {
    return fallback;
  }

  return <>{children}</>;
}
